import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { operations, selectors } from './duck';
import Presenter from './presenter';

const mapStateToProps = state => ({
  open: selectors.selectOpen(state),
  httpError: selectors.selectHttpError(state),
});

const mapDispatchToProps = dispatch => ({
  handleClose: bindActionCreators(operations.closeError, dispatch),
});

const Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(Presenter);

export default Container;
